import PageHeader from "@/components/PageHeader";
import { SizeStockTab } from "@/pages/SizeIntelligence";

export default function Inventory() {
  return (
    <div className="space-y-6" data-testid="inventory-page">
      <PageHeader title="Inventory" subtitle="Finished goods stock — matching leads get an instant in-stock alert" />
      <SizeStockTab />
    </div>
  );
}
